/**
 * Minicart Related Products
 * - Añade el producto al carrito vía Shopify Cart API (`/cart/add.js`).
 * - No interfiere con la apertura/cierre del cart drawer (usa stopPropagation
 *   y los botones son `type="button"` para no submitear el form padre).
 * - Tras agregar, emite `cartUpdate` del theme: el footer `MinimogCartDrawerFooter`
 *   se re-rendeerea con el liquid actualizado, y como el snippet filtra los
 *   productos ya presentes en el carrito, el producto desaparece de la lista.
 * - Aplica un fade-out optimista antes del re-render para una transición fluida.
 */
(function () {
    var BUTTON_SELECTOR = '[data-minicart-related-add]';
    var ITEM_SELECTOR = '[data-minicart-related-item]';
    var ROOT_SELECTOR = '[data-minicart-related]';
    var LIST_SELECTOR = '[data-minicart-related-list]';
    var PREV_SELECTOR = '[data-minicart-related-prev]';
    var NEXT_SELECTOR = '[data-minicart-related-next]';
  
    function getRoutes() {
      return (window.MinimogSettings && window.MinimogSettings.routes) || {};
    }
  
    function emitCartUpdate(response) {
      if (
        window.MinimogEvents &&
        typeof window.MinimogEvents.emit === 'function' &&
        window.MinimogTheme &&
        window.MinimogTheme.pubSubEvents
      ) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {
          cart: response,
          productVariantId: response && response.variant_id,
        });
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      }
    }
  
    function showError(message) {
      if (
        window.MinimogTheme &&
        window.MinimogTheme.Notification &&
        typeof window.MinimogTheme.Notification.show === 'function'
      ) {
        window.MinimogTheme.Notification.show({
          target: document.body,
          method: 'appendChild',
          type: 'error',
          message: message || 'No se pudo agregar el producto al carrito.',
          last: 3000,
          sticky: true,
        });
      } else {
        console.error('Minicart related:', message);
      }
    }
  
    function addToCart(variantId) {
      var routes = getRoutes();
      var addUrl = routes.cart_add_url || '/cart/add.js';
  
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
  
      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
      formData.append('sections', sectionsToBundle.join(','));
      formData.append('sections_url', window.location.pathname);
  
      return fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response && response.status) {
            throw new Error(response.message || response.description || 'Cart add error');
          }
          return response;
        });
    }
  
    function onAddClick(event) {
      var button = event.target.closest(BUTTON_SELECTOR);
      if (!button) return;
  
      event.preventDefault();
      event.stopPropagation();
  
      if (button.disabled || button.classList.contains('is-loading')) return;
  
      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;
  
      var item = button.closest(ITEM_SELECTOR);
  
      button.classList.add('is-loading');
      button.disabled = true;
  
      addToCart(variantId)
        .then(function (response) {
          if (item) item.classList.add('is-removing');
          emitCartUpdate(response);
        })
        .catch(function (error) {
          button.classList.remove('is-loading');
          button.disabled = false;
          showError(error && error.message);
        });
    }
  
    function getStepSize(list) {
      var firstItem = list.querySelector(ITEM_SELECTOR);
      if (!firstItem) return list.clientWidth;
      var rect = firstItem.getBoundingClientRect();
      var styles = window.getComputedStyle(list);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return rect.width + gap;
    }
  
    function updateNavState(root) {
      var list = root.querySelector(LIST_SELECTOR);
      var prev = root.querySelector(PREV_SELECTOR);
      var next = root.querySelector(NEXT_SELECTOR);
      if (!list || (!prev && !next)) return;
  
      if (list.clientWidth === 0 || list.scrollWidth === 0) return;
  
      var atStart = list.scrollLeft <= 1;
      var hasOverflow = list.scrollWidth > list.clientWidth + 1;
      var atEnd = !hasOverflow || list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
  
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }
  
    function scrollByStep(root, direction) {
      var list = root.querySelector(LIST_SELECTOR);
      if (!list) return;
      var step = getStepSize(list);
      list.scrollBy({ left: direction * step, behavior: 'smooth' });
    }
  
    function initSlider(root) {
      if (!root || root.dataset.minicartRelatedReady === 'true') return;
      var list = root.querySelector(LIST_SELECTOR);
      if (!list) return;
  
      updateNavState(root);
  
      list.addEventListener('scroll', function () {
        updateNavState(root);
      });
  
      window.addEventListener('resize', function () {
        updateNavState(root);
      });
  
      if (typeof ResizeObserver === 'function') {
        var ro = new ResizeObserver(function () {
          updateNavState(root);
        });
        ro.observe(list);
      }
  
      root.dataset.minicartRelatedReady = 'true';
    }
  
    function onNavClick(event) {
      var prev = event.target.closest(PREV_SELECTOR);
      var next = event.target.closest(NEXT_SELECTOR);
      if (!prev && !next) return;
  
      event.preventDefault();
      event.stopPropagation();
  
      var root = (prev || next).closest(ROOT_SELECTOR);
      if (!root) return;
  
      scrollByStep(root, prev ? -1 : 1);
    }
  
    function initAllSliders(scope) {
      var context = scope && scope.querySelectorAll ? scope : document;
      context.querySelectorAll(ROOT_SELECTOR).forEach(initSlider);
    }
  
    document.addEventListener('click', onAddClick);
    document.addEventListener('click', onNavClick);
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllSliders(document);
      });
    } else {
      initAllSliders(document);
    }
  
    document.addEventListener('shopify:section:load', function (event) {
      initAllSliders((event && event.target) || document);
    });
  
    document.addEventListener('cart:updated', function () {
      setTimeout(function () {
        initAllSliders(document);
      }, 0);
    });
  })();
  
  /**
   * Mega categories filter (collection sidebar)
   */
  (function () {
    var ROOT_SELECTOR = '[data-mega-categories-filter]';
    var SECTION_SELECTOR = '.facest-filters-section';
    var GRID_SELECTOR = '#CollectionProductGrid';
  
    function initMegaCategoriesFilter(root) {
      if (!root || root.dataset.megaCategoriesInit === 'true') return;
      root.dataset.megaCategoriesInit = 'true';
  
      var triggers = root.querySelectorAll('[data-mega-category-trigger]');
      var panels = root.querySelectorAll('[data-mega-category-panel]');
  
      function showPanel(index) {
        var indexStr = String(index);
        panels.forEach(function (panel) {
          var isActive = panel.dataset.megaCategoryPanel === indexStr;
          if (isActive) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
  
        triggers.forEach(function (trigger) {
          var isActive = trigger.dataset.megaCategoryTrigger === indexStr;
          trigger.classList.toggle('is-active', isActive);
          var listItem = trigger.closest('.m-link-lists--item');
          if (listItem) listItem.classList.toggle('active', isActive);
          if (isActive) trigger.setAttribute('aria-current', 'page');
          else trigger.removeAttribute('aria-current');
        });
      }
  
      function fetchCollectionPage(url) {
        var section = document.querySelector(SECTION_SELECTOR);
        var sectionId = section && section.dataset.sectionId;
        if (!sectionId) {
          window.location.href = url;
          return;
        }
  
        var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
  
        fetch(fetchUrl)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newSection = doc.querySelector(SECTION_SELECTOR);
            var newGrid = doc.querySelector(GRID_SELECTOR);
            var currentSection = document.querySelector(SECTION_SELECTOR);
            var currentGrid = document.querySelector(GRID_SELECTOR);
  
            if (newSection && currentSection) {
              currentSection.replaceWith(newSection);
            } else if (newGrid && currentGrid) {
              currentGrid.replaceWith(newGrid);
            }
  
            var newFilter = doc.querySelector(ROOT_SELECTOR);
            if (newFilter) {
              root.innerHTML = newFilter.innerHTML;
              root.dataset.megaCategoriesInit = 'false';
              initMegaCategoriesFilter(root);
            }
  
            if (window.MinimogTheme && window.MinimogTheme.Collection) {
              window.MinimogTheme.Collection.init();
            }
  
            document.dispatchEvent(new CustomEvent('collection:rerendered'));
            window.history.pushState({}, '', url);
          })
          .catch(function () {
            window.location.href = url;
          });
      }
  
      root.addEventListener('click', function (event) {
        var toggle = event.target.closest('[data-mega-filter-toggle]');
        if (toggle) {
          var dropdown = toggle.closest('[data-mega-filter-dropdown]');
          if (dropdown) {
            dropdown.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', dropdown.classList.contains('is-open'));
          }
          return;
        }
  
        var trigger = event.target.closest('[data-mega-category-trigger]');
        if (trigger) {
          event.preventDefault();
          showPanel(trigger.dataset.megaCategoryTrigger);
          return;
        }
  
        var subcategory = event.target.closest('[data-mega-subcategory-filter]');
        if (subcategory) {
          event.preventDefault();
          fetchCollectionPage(subcategory.href);
        }
      });
    }
  
    function initAllMegaCategoriesFilters(context) {
      (context || document).querySelectorAll(ROOT_SELECTOR).forEach(initMegaCategoriesFilter);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllMegaCategoriesFilters(document);
      });
    } else {
      initAllMegaCategoriesFilters(document);
    }
  
    document.addEventListener('shopify:section:load', function (event) {
      initAllMegaCategoriesFilters(event.target || document);
    });
  
    document.addEventListener('collection:rerendered', function () {
      initAllMegaCategoriesFilters(document);
    });
  })();
  
  /**
   * Pack popup (header)
   */
  (function () {
    function closePackPopup(popup) {
      popup.classList.remove('is-open');
      popup.setAttribute('hidden', '');
      document.documentElement.classList.remove('prevent-scroll');
    }
  
    function openPackPopup(popup) {
      popup.removeAttribute('hidden');
      popup.classList.add('is-open');
      document.documentElement.classList.add('prevent-scroll');
    }
  
    function bindPackPopupTriggers(context) {
      (context || document).querySelectorAll('[data-pack-popup-open]').forEach(function (trigger) {
        if (trigger.dataset.packPopupBound === 'true') return;
        trigger.dataset.packPopupBound = 'true';
  
        trigger.addEventListener('click', function (event) {
          var popupId = trigger.getAttribute('data-pack-popup-open');
          var popup = popupId && document.getElementById(popupId);
          if (!popup) return;
          event.preventDefault();
          openPackPopup(popup);
        });
      });
    }
  
    function initPackPopups(context) {
      (context || document).querySelectorAll('[data-pack-popup]').forEach(function (popup) {
        if (popup.dataset.packPopupInit === 'true') return;
        popup.dataset.packPopupInit = 'true';
  
        popup.querySelectorAll('[data-pack-popup-close]').forEach(function (closeEl) {
          closeEl.addEventListener('click', function (event) {
            event.preventDefault();
            closePackPopup(popup);
          });
        });
  
        var submit = popup.querySelector('[data-pack-popup-submit]');
        if (submit) {
          submit.addEventListener('click', function () {
            var checked = popup.querySelector('.m-pack-popup__option-input:checked');
            if (checked && checked.value) {
              window.location.href = checked.value;
            }
          });
        }
      });
  
      bindPackPopupTriggers(context);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initPackPopups(document);
      });
    } else {
      initPackPopups(document);
    }
  
    document.addEventListener('shopify:section:load', function (event) {
      initPackPopups(event.target || document);
    });
  })();
  
  /**
   * Mega menu double-banner: estado unificado del panel (nivel 1, columna blanca y banners).
   */
  (function () {
    function getSiteNav() {
      return window.__sfHeader && window.__sfHeader.siteNav;
    }
  
    function keepMegaMenuOpen(megaMenu) {
      var menuItem = megaMenu.closest('.m-menu__item');
      if (!menuItem) return;
  
      menuItem.classList.add('m-menu__item--active');
  
      var siteNav = getSiteNav();
      if (!siteNav) return;
  
      clearTimeout(siteNav.timeoutLeave);
      clearTimeout(siteNav.timeoutEnter);
  
      var index = menuItem.dataset.index;
      if (index != null && index !== '') {
        siteNav.activeIndex = Number(index);
        siteNav.lastActiveIndex = Number(index);
      }
  
      if (siteNav.container) {
        siteNav.container.classList.add('m-mega-active');
      }
    }
  
    function setActiveBannerLayer(megaMenu, index) {
      var banner = megaMenu.querySelector('.m-mega-double-banner');
      if (!banner) return;
  
      var defaultLayer = banner.querySelector('.m-mega-double-banner__layer--default');
      var hoverLayers = banner.querySelectorAll('[data-hover-layer]');
      var hasHoverLayers = hoverLayers.length > 0;
      var activeIndex = index != null ? String(index) : null;
  
      if (defaultLayer) {
        defaultLayer.classList.toggle('is-active', !hasHoverLayers || activeIndex === 'default');
      }
  
      hoverLayers.forEach(function (layer) {
        layer.classList.toggle(
          'is-active',
          activeIndex !== null && activeIndex !== 'default' && layer.dataset.hoverLayer === activeIndex
        );
      });
    }
  
    function setActiveLevel1Item(megaMenu, item) {
      megaMenu.querySelectorAll('.m-sub-menu__item--level-1[data-hover-index]').forEach(function (el) {
        el.classList.toggle('is-megamenu-active', el === item);
      });
    }

    function isMegaMenuOpen(menuItem) {
      if (!menuItem) return false;
      var siteNav = getSiteNav();
      return (
        menuItem.classList.contains('m-menu__item--active') &&
        siteNav &&
        siteNav.container &&
        siteNav.container.classList.contains('m-mega-active')
      );
    }

    function syncPanelVisualState(megaMenu, item, index) {
      if (item) {
        setActiveLevel1Item(megaMenu, item);
      }
      setActiveBannerLayer(megaMenu, index != null ? index : 'default');
    }
  
    function initDoubleBannerMegamenu(context) {
      (context || document).querySelectorAll('.m-mega-menu--double-banner').forEach(function (megaMenu) {
        if (megaMenu.dataset.doubleBannerInit === 'true') return;
        megaMenu.dataset.doubleBannerInit = 'true';
  
        var menuItem = megaMenu.closest('.m-menu__item');
        var items = Array.from(megaMenu.querySelectorAll('.m-sub-menu__item--level-1[data-hover-index]'));
        var lastHoverIndex = items[0] ? items[0].dataset.hoverIndex : 'default';
  
        function getItemByIndex(index) {
          return megaMenu.querySelector('[data-hover-index="' + index + '"]');
        }
  
        function applyPanelState(item) {
          if (!isMegaMenuOpen(menuItem)) return;

          if (item) {
            lastHoverIndex = item.dataset.hoverIndex;
          }

          syncPanelVisualState(megaMenu, item || getItemByIndex(lastHoverIndex) || items[0], lastHoverIndex);
          keepMegaMenuOpen(megaMenu);
          megaMenu.classList.add('is-panel-interacting');
        }

        function resetPanelVisualState() {
          megaMenu.classList.remove('is-panel-interacting');
          megaMenu.querySelectorAll('.m-sub-menu__item--level-1.is-megamenu-active').forEach(function (el) {
            el.classList.remove('is-megamenu-active');
          });
          lastHoverIndex = items[0] ? items[0].dataset.hoverIndex : 'default';
          setActiveBannerLayer(megaMenu, lastHoverIndex);
        }

        if (!items.length) {
          setActiveBannerLayer(megaMenu, 'default');
          return;
        }

        function handlePanelInteraction(event) {
          if (!megaMenu.contains(event.target)) return;
          if (!isMegaMenuOpen(menuItem)) return;

          var level1Item = event.target.closest('.m-sub-menu__item--level-1[data-hover-index]');
          if (level1Item && megaMenu.contains(level1Item)) {
            applyPanelState(level1Item);
            return;
          }

          syncPanelVisualState(megaMenu, getItemByIndex(lastHoverIndex) || items[0], lastHoverIndex);
          megaMenu.classList.add('is-panel-interacting');
          keepMegaMenuOpen(megaMenu);
        }

        megaMenu.addEventListener('mouseover', handlePanelInteraction);

        megaMenu.addEventListener('mouseleave', function (event) {
          var related = event.relatedTarget;
          if (related && menuItem && menuItem.contains(related)) return;
          resetPanelVisualState();
        });

        resetPanelVisualState();
      });
    }
  
    function initAll(context) {
      initDoubleBannerMegamenu(context);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
  
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target || document);
    });
  })();
